import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../redux/slices/tabsSlice";

const TabButtons = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.tabs.activeTab);

  const handleTabChange = (tab) => {
    dispatch(setActiveTab(tab));
  };

  return (
    <div
      className={`tabs-container-calendar ${activeTab === "plan" ? "gradient-left" : "gradient-right"
        }`}
    >
      {["plan", "thoughts"].map((tab) => (
        <button
          key={tab}
          className={`tab-button ${activeTab === tab ? "active" : ""}`}
          onClick={() => handleTabChange(tab)}
        >
          {activeTab === tab && (
            <div className="dot-container">
              <div className="outer-dot">
                <div className="inner-dot"></div>
              </div>
            </div>
          )}
          {tab === "plan" ? "Планнер" : "Саморефлексия"}
        </button>
      ))}
    </div>
  );
};

export default TabButtons;
